export default __webpack_public_path__ + "static/media/2014.36488af7.png";